// extracted by mini-css-extract-plugin
export default {"publication":"publication_publication__Sw39e","post":"publication_post__y4AwT"};